<style>
  .notLogin {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    & > .header-wrapper{
      width: 1200px;
      margin: auto;
    }
  }
  .nav .domain-select {
    padding: 0;
  }
</style>
<template lang="pug">
#wrap
    header.header(:class="{'notLogin': !userName || unionLoginFailed }")
      div.header-wrapper
          h1.logo
              a(href="/web/overview") website
          #login_info
              .unsigned(v-if="!userName")
                  li(style="position: relative;")
                      a(href="javascript:;", @click="toggleLoginPane", :class="{on: loginShown}") 登录
                      Login(
                          v-if="!userName",
                          :visible="loginShown",
                          system="pcw_i360",
                          types="normal",
                          :reload="false",
                          redirect="/login/doAuth"
                      )
              .nav-right(style="float: right;")
                  a(href="/present", target="_blank" v-if="!userName") 产品介绍 
                  a(href="https://fenxi.360.cn/help", target="_blank") 帮助中心
                  a(href="https://fenxi.360.cn/help/contact", target="_blank") 联系我们
                  template(v-if="!!userName")
                      span |
                      a(:href="'http://i.360.cn/?u=' + userName", target="_blank") {{userName}}
                      a.logout(href="/login/exit") 退出
          ul.nav(v-if="!!userName && !unionLoginFailed")
              li(v-if="userName &&　domainList.length")
                DomainSelect(label="" @change="onDomainChange")
              
              li(v-if="domainList.length === 0")
                  a 网站分析
              li
                  router-link(to="/app") 应用推广
              li(v-reddot="settingReddot")
                  router-link(to="/setting") 设置中心
    slot
</template>

<script>
export default {
  data () {
    return {
      settingReddot: {
        key: 'setting',
        top: '14px',
        right: '11px'
      },
      userName: window.$userName || '',
      unionLoginFailed: false,
      loginShown: false
    }
  },
  computed: {
    domainList () {
      return this.$store.state.domainList || []
    }
  },
  methods: {
    toggleLoginPane (e) {
      this.loginShown = !this.loginShown
    },
    onDomainChange () {
      this.$router.push('/web/overview')
    }
  }
}
</script>

<style scoped>
#login_info {
    float: right;
    font-size: 12px;
    margin-top: 8px;
}
@media screen and (max-width: 1000px) {
    #login_info > .nav-right {
        display: none;
    }
}
.nav-right {
    > a,
    > span {
        display: inline-block;
        margin-right: 15px;
        color: #fff;
        padding: 0 0.5em;
        &:hover {
          border-bottom: 2px solid #fff;
        }
      }
    > span:hover {
      border-bottom: 0;
    }
    > a.logout {
      margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// navbar.vue?630af2e6